var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTarjetas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "27px",
    viewBox: "0 0 33 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "20.5 Tarjetas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.1-PerfilMiPerfil",
    transform: "translate(-88.000000, -505.000000)",
    stroke: "#1D1D1B",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "20.5-Tarjetas",
    transform: "translate(89.292431, 506.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.042108 L0,2.95789202 C0,1.3239473 1.19301649,0 2.66537342,0 L27.3355965,0 C28.8069835,0 30,1.3239473 30,2.95789202 L30,22.042108 C30,23.6749763 28.8069835,25 27.3355965,25 L2.66537342,25 C1.19301649,25 0,23.6749763 0,22.042108 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 6.32771463,
    x2: 30,
    y2: 6.32771463,
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0387927,19.1836735 L21.3467666,19.1836735 C20.8591665,19.1836735 20.4652114,18.788642 20.4652114,18.3021183 L20.4652114,15.6100921 C20.4652114,15.122492 20.8591665,14.7274606 21.3467666,14.7274606 L24.0387927,14.7274606 C24.5253165,14.7274606 24.9203479,15.122492 24.9203479,15.6100921 L24.9203479,18.3021183 C24.9203479,18.788642 24.5253165,19.1836735 24.0387927,19.1836735 Z",
    id: "Stroke-5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarjetas);
export default __webpack_public_path__ + "static/media/Tarjetas.66aac89fa83385982f22776b4324afd8.svg";
export { ForwardRef as ReactComponent };